import { useEffect, useState } from 'react';
import {
  combatHaptic,
  getCombatHapticsEnabled,
  setCombatHapticsEnabled,
  stopCombatHaptics,
  supportsCombatHaptics,
} from '../../utils/combatHaptics';
import './HapticsToggle.css';

const HapticsToggle = () => {
  const [enabled, setEnabled] = useState(getCombatHapticsEnabled);
  const supported = supportsCombatHaptics();
  useEffect(() => {
    if (!supported) return undefined;
    const onVisibilityChange = () => {
      if (document.hidden) stopCombatHaptics();
    };
    document.addEventListener('visibilitychange', onVisibilityChange);
    window.addEventListener('pagehide', stopCombatHaptics);
    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange);
      window.removeEventListener('pagehide', stopCombatHaptics);
      if (supported) stopCombatHaptics();
    };
  }, [supported]);
  if (!supported) return null;
  return (
    <button
      type="button"
      className="coreboundBack neonButton coreboundHapticsButton"
      aria-label="Combat vibrations"
      aria-pressed={enabled}
      title={`Combat vibrations ${enabled ? 'on' : 'off'} — turn on to test`}
      onClick={() => {
        const nextEnabled = !enabled;
        setCombatHapticsEnabled(nextEnabled);
        setEnabled(nextEnabled);
        // Keep the test in the tap handler so the browser sees a user gesture.
        if (nextEnabled) combatHaptic('dealt');
      }}
    >
      <svg viewBox="0 0 28 28" aria-hidden="true">
        <rect x="9" y="5" width="10" height="18" rx="2" />
        <path d="M12 20H16" />
        {enabled ? (
          <path d="M5 9 3 12 5 15 3 18M23 9 25 12 23 15 25 18" />
        ) : (
          <path d="M4 24 24 4" />
        )}
      </svg>
    </button>
  );
};

export default HapticsToggle;
